import { render, staticRenderFns } from "./BadgesDialog.vue?vue&type=template&id=5ad61d32&"
import script from "./BadgesDialog.vue?vue&type=script&lang=js&"
export * from "./BadgesDialog.vue?vue&type=script&lang=js&"
import style0 from "./BadgesDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports